require.register("modules/m06/a03/page-22/page-22", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_22 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_22;


  
});

